import { useIframePoolStore } from "@/components/Canvas/IframePool/iframePoolStore";
import {
  CursorType,
  revertCursorType,
  setCursorType,
} from "@/store/globalSettingsSlice";
import {
  setHoveredElementKey,
  setSelectedElementKey,
} from "@/store/iframeSlice";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

const useToggleDriveMode = (
  options: { fromKey: boolean } = {
    fromKey: false,
  },
) => {
  const { fromKey } = options;

  const dispatch = useDispatch();
  const cursorType = useSelector(
    (state: any) => state.globalSettings.cursorType,
  );

  const toggleCursor = useCallback(() => {
    if (cursorType !== CursorType.Drive) {
      dispatch(
        setCursorType({
          cursorType: CursorType.Drive,
          fromKeyDown: fromKey,
        }),
      );
      dispatch(setSelectedElementKey(null));
      dispatch(setHoveredElementKey(null));
    } else {
      // Restore the previous layout
      dispatch(revertCursorType());
      useIframePoolStore.getState().requestNavTreeForAllStoryboards();
    }
  }, [cursorType, fromKey]);

  return { toggleCursor };
};

export default useToggleDriveMode;
